import { createFileRoute } from '@tanstack/react-router'
import { DateTime } from 'luxon'
import { Boundary, PageActionPortal, UsageMonthSelector } from '~/components'
import { UsageBotSelector } from '~/components/UsageBotSelector'
import { BotAiSpend } from '~/features/usage/components/BotAiSpend'
import { SELECTED_MONTH_FORMAT, UsageOptions } from './index'
import { useLocalStore } from '~/stores'
import { useNavbarActions } from '~/providers/NavbarACtionsContext'
import { useEffect } from 'react'

export const Route = createFileRoute('/workspaces/$workspaceId/usage/ai-spend')({
  component: RouteComponent,
  validateSearch: UsageOptions,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { workspaceId } = Route.useParams()
  const { selectedMonth: unparsedSelectedMonth, botId: selectedBotId } = Route.useSearch()
  const lastBotId = useLocalStore((state) => state.getLastActiveBotId(workspaceId))
  const { setNavbarActions } = useNavbarActions()

  const selectedMonth = DateTime.fromFormat(unparsedSelectedMonth, SELECTED_MONTH_FORMAT).toJSDate()

  useEffect(() => {
    setNavbarActions(
      <UsageBotSelector
        workspaceId={workspaceId}
        selectedBotId={selectedBotId ?? lastBotId}
        onChange={(botId) =>
          navigate({
            from: Route.fullPath,
            to: Route.fullPath,
            search: (prev) => ({ ...prev, botId: botId }),
          })
        }
      />
    )
    return () => setNavbarActions(null)
  }, [workspaceId, selectedBotId, lastBotId, navigate, setNavbarActions])

  return (
    <>
      <PageActionPortal>
        <UsageMonthSelector
          selectedMonth={selectedMonth}
          debouncedOnChange={(date) =>
            navigate({
              from: Route.fullPath,
              to: Route.fullPath,
              search: (prev) => ({ ...prev, selectedMonth: DateTime.fromJSDate(date).toFormat(SELECTED_MONTH_FORMAT) }),
            })
          }
          className="ml-auto"
        />
      </PageActionPortal>
      <Boundary>
        <BotAiSpend
          selectedMonth={selectedMonth}
          workspaceId={workspaceId}
          selectedBotId={selectedBotId ?? lastBotId}
        />
      </Boundary>
    </>
  )
}
